<template>
  <form @submit.prevent="save">
    <v-container fluid>
      <v-card-text>
        <v-text-field
          v-model="form.email"
          label="E-Mail"
          append-icon="mdi-email"
          outlined
          class="form-control"
          type="email"
          name="email"
          autocomplete="username"
          :class="{ 'is-invalid': form.errors.email }"
          :error="form.errors.email"
          :error-messages="form.errors.email"
        />
        <v-text-field
          v-model="form.password"
          label="Passwort"
          outlined
          :class="{ 'is-invalid': form.errors.password }"
          class="form-control"
          name="password"
          autocomplete="current-password"
          :error="form.errors.password"
          :error-messages="form.errors.password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
        />
      </v-card-text>
      <v-card-actions>
        <v-checkbox
          v-model="form.remember"
          label="Angemeldet bleiben"
          color="#033"
        />
        <v-spacer />
        <v-btn
          depressed
          :loading="loading"
          color="primary"
          type="submit"
        >
          Login
        </v-btn>
      </v-card-actions>
      <inertia-link class="v-btn v-btn--flat v-btn--text theme--light v-size--small primary--text" :href="route('password.request')" method="get">
        Password vergessen?
      </inertia-link>
    </v-container>
  </form>
</template>

<script>
export default {
   components: {
      //
   },
   data () {
      return {
         loading: false,
         showPassword: false,
         form: this.$inertia.form({
            email: null,
            password: null,
            remember: null,
         }),
      }
   },
   methods: {
      save () {
         this.loading = true
         this.form.post(this.route('login')).then(() => this.loading = false)
      },
   },
}
</script>
